<button
  mat-button
  (click)="shareRequirements()"
>
  Share Requirements
</button>
